import {
  MakeMaybe,
  MakeNonNullable,
  ParsedTaskFragment,
  PatientPreferenceValue,
  PatientPreferencesField as Pref,
} from '@valerahealth/rtk-query'

export enum ColumnKey {
  type = 'type',
  status = 'status',
  patient = 'patient',
  serviceType = 'serviceType',
  referralSource = 'referralSource',
  description = 'description',
  assignee = 'assignee',
  dueDate = 'dueDate',
  comment = 'comment',
  createdBy = 'createdBy',
  createdDate = 'createdDate',
  lastComment = 'lastComment',
  lastCommentDate = 'lastCommentDate',
  actions = 'actions',
  patientPreferences = 'patientPreferences',
  patientPreferencesServiceType = 'patientPreferences.value.serviceTypes',
  patientPreferencesInsurancePlans = 'patientPreferences.value.insurancePlans',
  patientPreferencesServiceLocations = 'patientPreferences.value.serviceLocations',
  patientPreferencesLegalSex = 'patientPreferences.value.legalSex',
  patientPreferencesRaces = 'patientPreferences.value.races',
  patientPreferencesEthnicities = 'patientPreferences.value.ethnicities',
  patientPreferencesLanguages = 'patientPreferences.value.languages',
  patientPreferencesSpiritualities = 'patientPreferences.value.spiritualities',
  patientPreferencesClinicalAges = 'patientPreferences.value.clinicalAges',
  patientPreferencesClinicalSpecialties = 'patientPreferences.value.clinicalSpecialties',
  patientPreferencesClinicalModalities = 'patientPreferences.value.clinicalModalities',
  patientPreferencesGenderIdentity = 'patientPreferences.value.genderIdentity',
  patientPreferencesCommunityIdentities = 'patientPreferences.value.communityIdentities',
  patientPreferencesTime = 'patientPreferences.value.time',
  patientPreferencesDuration = 'patientPreferences.value.duration',
  patientPreferencesDayOfWeek = 'patientPreferences.value.dayOfWeek',
  patientPreferencesDayPart = 'patientPreferences.value.dayPart',
  selection = '__check__', 
}

export const PATIENT_PREFERENCE_TASK = {
  [Pref.serviceType]: ColumnKey.patientPreferencesServiceType,
  [Pref.insurancePlan]: ColumnKey.patientPreferencesInsurancePlans,
  [Pref.locations]: ColumnKey.patientPreferencesServiceLocations,
  [Pref.legalSex]: ColumnKey.patientPreferencesLegalSex,
  [Pref.genderIdentity]: ColumnKey.patientPreferencesGenderIdentity,
  [Pref.race]: ColumnKey.patientPreferencesRaces,
  [Pref.ethnicity]: ColumnKey.patientPreferencesEthnicities,
  [Pref.languages]: ColumnKey.patientPreferencesLanguages,
  [Pref.spirituality]: ColumnKey.patientPreferencesSpiritualities,
  [Pref.clinicalAges]: ColumnKey.patientPreferencesClinicalAges,
  [Pref.clinicalSpecialties]: ColumnKey.patientPreferencesClinicalSpecialties,
  [Pref.clinicalModalities]: ColumnKey.patientPreferencesClinicalModalities,
  [Pref.communityIdentity]: ColumnKey.patientPreferencesCommunityIdentities,
  [Pref.dayOfWeek]: ColumnKey.patientPreferencesDayOfWeek,
  [Pref.time]: ColumnKey.patientPreferencesTime,
  [Pref.duration]: ColumnKey.patientPreferencesDuration,
  [Pref.dayPart]: ColumnKey.patientPreferencesDayPart,
} as const

type PartialTaskFields = Pick<
  ParsedTaskFragment,
  'type' | 'status' | 'referralSource' | 'serviceType' | 'assignee'
>

export type PatientTaskField = {
  patientId: string
  treatmentId: string
  display?: string | null
  mrn?: string | null
  nextgenId?: string | null
  lumaId?: string | null
}

export type TaskFormType = MakeMaybe<
  PartialTaskFields,
  keyof PartialTaskFields
> & {
  dueDate: Date | null
  patient: PatientTaskField | null
  comment: string
  description: string
  patientPreferences: PatientPreferenceValue
}
// after validation
export type SubmittedTaskFormType = Pick<
  TaskFormType,
  | 'serviceType'
  | 'referralSource'
  | 'comment'
  | 'description'
  | 'patient'
  | 'patientPreferences'
> &
  // required fields
  MakeNonNullable<
    Pick<TaskFormType, 'assignee' | 'dueDate' | 'type' | 'status'>
  >
